import type { FC } from "react";
import React from "react";

const AppDialogTarget: FC = () => {
  return <div id="appDialogTarget"></div>;
};

export default AppDialogTarget;
